import FlatButton from '@/components/flat-button';
import useMessageTray from '@/hooks/use-message-tray.hook';
import { getBreakpoint } from '@/theme';
import { Stack, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  closeable?: boolean;
  children?: ReactNode;
}

const useStyles = createUseStyles<string, { closeable: boolean }>((theme: Theme) => ({
  messageTrayFooter: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 40,
    gap: 8,
    padding: '0px 30px',
    backgroundColor: theme.palette.background.traybar,
    cursor: ({ closeable }) => (closeable ? 'pointer' : 'default'),
  },
  [getBreakpoint('md')]: {
    messageTrayFooter: {
      height: 40,
      padding: '0px 10px',
    },
  },
}));

const MessageTrayFooter: FC<Props> = ({ children, closeable = true }) => {
  const styles = useStyles({ closeable });
  const { closeAll } = useMessageTray();

  const handleCloseTray = () => {
    closeAll();
  };

  return (
    <Stack
      className={styles.messageTrayFooter}
      flexDirection="row"
      justifyContent="flex-end"
      alignItems="center"
      gap={1}
      width="100%"
      role="button"
      onClick={closeable ? handleCloseTray : undefined}
    >
      {closeable && <FlatButton icon="close" label="Close" size="small" responsive={false} />}
      {children}
    </Stack>
  );
};

export default MessageTrayFooter;
